/**
 * Issue #235 — 删除图形验证码 API 客户端（真实接口）。
 *
 * 发起任一删除前先 POST /admin/delete-captcha 拿到 captchaId + SVG，用户输入后随删除
 * 请求回传，由各删除接口后端 consume 校验（一次性）。绝不前端本地校验。
 */
import { apiClient } from './api';

/** 与后端 DELETE_CAPTCHA_ACTIONS 对齐。 */
export type DeleteCaptchaAction =
  | 'employee:delete'
  | 'department:delete'
  | 'course:delete'
  | 'knowledge:delete'
  // Issue #235（rework R1）：补齐 ASR 密钥清空 + 岗位删除两个管理端删除入口。
  | 'asr-credential:clear'
  | 'position:delete'
  // Issue #343：删除 DeepSeek Key。
  | 'deepseek-credential:remove'
  // Issue #8：软删除通话记录（DELETE /calls/:id）。
  | 'call:delete';

export interface DeleteCaptcha {
  captchaId: string;
  svg: string;
  expiresInSec: number;
}

export function issueDeleteCaptchaApi(
  action: DeleteCaptchaAction,
): Promise<DeleteCaptcha> {
  return apiClient.post<DeleteCaptcha>('/admin/delete-captcha', { action });
}

/** 删除请求统一携带的验证码字段（随 DELETE body 发往后端校验）。 */
export interface DeleteCaptchaProof {
  captchaId: string;
  captchaCode: string;
}
